import ProductImageGallerySlider, { ProductImageGallerySliderProps } from './ProductImageGallerySlider'

export default ProductImageGallerySlider

export { ProductImageGallerySlider }
export type { ProductImageGallerySliderProps }
